import {colors} from 'shells/colors/colors';

import {LeadFitScore} from 'nutshell-graphql-types';

export const BACKGROUND_PATH =
    'M19.398 11.592c1.215 1.87.74 4.344-.886 5.87q-.385.361-.76.736a33.5 33.5 0 0 0-9.284 17.764c-.395 2.196-2.212 3.942-4.443 3.942-2.407 0-4.345-2.018-3.978-4.397a41.9 41.9 0 0 1 13.499-24.858c1.795-1.602 4.542-1.075 5.852.943m44.12.009c1.311-2.018 4.06-2.545 5.855-.943q.875.78 1.708 1.615a41.9 41.9 0 0 1 11.781 23.234c.367 2.379-1.571 4.397-3.978 4.397-2.231 0-4.048-1.746-4.443-3.942A33.5 33.5 0 0 0 64.404 17.47c-1.625-1.527-2.1-4-.885-5.87M41.456 0a41.9 41.9 0 0 1 17.2 3.696c2.193.988 2.83 3.712 1.519 5.73-1.215 1.87-3.668 2.442-5.724 1.577a33.5 33.5 0 0 0-25.982-.005c-2.055.864-4.507.292-5.721-1.578-1.31-2.018-.674-4.742 1.52-5.73A41.9 41.9 0 0 1 41.455 0';

export const ARC_SECTIONS = {
    left: 'M19.398 11.59c1.214 1.871.739 4.345-.887 5.871A33.53 33.53 0 0 0 8.464 35.965c-.395 2.195-2.211 3.941-4.441 3.941-2.407 0-4.345-2.018-3.978-4.396a41.9 41.9 0 0 1 13.5-24.861c1.795-1.603 4.542-1.076 5.853.942',
    top: 'M41.456 0a41.9 41.9 0 0 1 17.2 3.696c2.193.988 2.83 3.712 1.519 5.73-1.215 1.87-3.668 2.442-5.724 1.577a33.5 33.5 0 0 0-25.982-.005c-2.055.864-4.507.292-5.721-1.578-1.31-2.018-.674-4.742 1.52-5.73A41.9 41.9 0 0 1 41.455 0',
    right: 'M63.518 11.601c1.311-2.018 4.06-2.545 5.855-.943q.875.78 1.708 1.615a41.9 41.9 0 0 1 11.781 23.234c.367 2.379-1.571 4.397-3.978 4.397-2.231 0-4.048-1.746-4.443-3.942A33.5 33.5 0 0 0 64.404 17.47c-1.625-1.527-2.1-4-.885-5.87',
};

export const NEEDLE_PATH =
    'M40.714 16.612c.096-.826 1.295-.826 1.39 0l2.31 20.018a3.024 3.024 0 1 1-6.01 0z';

export const centerX = 41.5;
export const centerY = 36.6;

interface GaugeConfig {
    rotation: number;
    color: string | undefined;
    fillAmount: number;
}

export const GAUGE_CONFIG: Record<LeadFitScore, GaugeConfig> = {
    [LeadFitScore.UNLIKELY]: {
        rotation: -90,
        color: colors.rose,
        fillAmount: 1,
    },
    [LeadFitScore.POSSIBLE]: {
        rotation: 0,
        color: colors.yellow,
        fillAmount: 2,
    },
    [LeadFitScore.IDEAL]: {
        rotation: 90,
        color: colors.greenDk,
        fillAmount: 3,
    },
    [LeadFitScore.UNKNOWN]: {
        rotation: 0,
        color: colors.offWhiteDk,
        fillAmount: 0,
    },
};
